import React from "react";
import { BarChart, Bar, XAxis, YAxis, Cell, ResponsiveContainer } from "recharts";
import _ from "lodash";
import { AiFillCaretRight, AiFillCaretLeft } from "react-icons/ai";
import { TransactionType } from "../../../utils/constants";

const expenseColors = ["#ffa600", "#ff6361", "#58508d", "#bc5090", "#003f5c"];
const incomeColors = ["#E2E062", "#A6C760", "#73AC61", "#297159", "#15534C"];

class SummaryBars extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transactions: props.transactions,
            description: props.description,
            mode: props.mode,
            categoryWasClicked: props.categoryWasClicked,
            categoryWasUnclicked: props.categoryWasUnclicked,
            data: [],
            selectedCategoryId: null
        };
    }

    parseData(data, mode) {
        const colors = mode === TransactionType.INCOME ? incomeColors : expenseColors;
        data.forEach((item, index) => {
            item.color = colors[index % colors.length];
        });

        const dataChunks = _.chunk(data.reverse(), 5);
        this.setState({ dataChunks, currentChunkIndex: 0 });

        return dataChunks[0];
    }

    setItems(items) {
        if (!items || !Object.keys(items).length) {
            this.setState({ data: [] });
        } else {
            const data = this.parseData(items, this.state.mode);
            this.setState({ data });
        }
    }

    categoryClick = (categoryData) => {
        if (this.state.categoryWasClicked) {
            if (this.state.selectedCategoryId === categoryData.categoryId) {
                this.setState({ selectedCategoryId: null });
                this.state.categoryWasUnclicked();
            } else {
                this.setState({ selectedCategoryId: categoryData.categoryId });
                this.state.categoryWasClicked(this.state.mode, categoryData.categoryId, categoryData.category);
            }
        }
    };

    nextChunk = () => {
        const nextChunkIndex = this.state.currentChunkIndex + 1;
        const nextChunk = this.state.dataChunks[nextChunkIndex];
        if (nextChunk) {
            this.setState({
                data: nextChunk,
                currentChunkIndex: nextChunkIndex
            });
        }
    };

    previousChunk = () => {
        const prevChunkIndex = this.state.currentChunkIndex - 1;
        const prevChunk = this.state.dataChunks[prevChunkIndex];
        if (prevChunk) {
            this.setState({
                data: prevChunk,
                currentChunkIndex: prevChunkIndex
            });
        }
    };

    render() {
        return (
            <div style={{ width: "100%", height: "100%" }}>
                <div>
                    <div>
                        <AiFillCaretLeft
                            style={{
                                fontSize: "25px",
                                marginLeft: "12px",
                                marginTop: "8px",
                                color: "gray"
                            }}
                            onClick={this.previousChunk}
                        />
                        <AiFillCaretRight
                            style={{
                                fontSize: "25px",
                                float: "right",
                                marginRight: "12px",
                                marginTop: "8px",
                                color: "gray"
                            }}
                            onClick={this.nextChunk}
                        />
                    </div>
                    <ResponsiveContainer width={"99%"} minHeight={200}>
                        <BarChart
                            data={this.state.data}
                            margin={{
                                top: 25,
                                right: 30,
                                left: 20,
                                bottom: 5
                            }}
                        >
                            <XAxis dataKey="category" />
                            <YAxis scale="log" domain={["auto", "auto"]} hide={true} />
                            <Bar
                                onClick={this.categoryClick}
                                dataKey="amount"
                                label={{ position: "top", fill: "black" }}
                            >
                                {this.state.data.map((categoryData, index) => {
                                    if (this.state.selectedCategoryId) {
                                        if (this.state.selectedCategoryId === categoryData.categoryId) {
                                            return <Cell key={index} fill={categoryData.color} stroke={"black"} />;
                                        } else {
                                            return <Cell key={index} fill={"#ededed"} />;
                                        }
                                    } else {
                                        return <Cell key={index} fill={categoryData.color} />;
                                    }
                                })}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    }
}

export default SummaryBars;
